// extracted by mini-css-extract-plugin
module.exports = {"tagSectionItem":"TagSectionItem_tagSectionItem__29Bgz","sectionHeader":"TagSectionItem_sectionHeader__6qCRx","tagTypeList":"TagSectionItem_tagTypeList__3pbA4"};